<div class="content" *ngIf="role" style="padding: 5px">
  <div class="row">
    <div class="col-md-8">
      <div class="page-header">
        <div class="help-block h4">
          Role properties
          <close-button></close-button>
        </div>
        <hr />
      </div>
    </div>
  </div>

  <div class="accordion clear:both" id="SecurityEditAccordion" [closeOthers]="true">
    <div class="accordion-item" #properties [isOpen]="true">
      <div class="accordion-header" id="headingOne">
        <div class="row" style="cursor: pointer" *ngIf="!role.isNew">
          <div class="col-xs-12">
            <h5 class="mb-0">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <span class="material-icons">admin_panel_settings</span>Role [<span
                  >{{ role.name }}</span
                >]
              </button>
            </h5>
          </div>
        </div>
      </div>
      <div
        id="collapseOne"
        class="accordion-collapse collapse show"
        aria-labelledby="headingOne"
        data-parent="#SecurityEditAccordion"
      >
        <div class="accordion-body">
          <div class="row">
            <div class="col-md-8">
              <form aria-label="properties" class="form-horizontal" role="form" #formRef="ngForm">
                <div class="form-group">
                  <label for="name" class="col-md-2 control-label">Name</label>
                  <div class="col-md-10">
                    <input
                      [disabled]="role.id == 1"
                      type="text"
                      class="form-control"
                      placeholder="Role Name"
                      [(ngModel)]="role.name"
                      name="name"
                      #name="ngModel"
                      (blur)="updateRoleInfo()"
                      required
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="description" class="col-md-2 control-label">Description</label>
                  <div class="col-md-10">
                    <textarea
                      class="form-control"
                      placeholder="Role Description"
                      [(ngModel)]="role.description"
                      name="description"
                      #description="ngModel"
                      (blur)="updateRoleInfo()"
                    >
                    </textarea>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion-item" #permissions *ngIf="!role.isNew" [isOpen]="false">
      <div class="accordion-header" id="headingTwo">
        <div class="row" style="cursor: pointer">
          <div class="col-xs-12">
            <h5 class="mb-0">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
              >
                <span class="material-icons">list_alt</span>Permissions
              </button>
            </h5>
          </div>
        </div>
      </div>
      <div
        id="collapseTwo"
        class="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-parent="#SecurityEditAccordion"
      >
        <div class="accordion-body">
          <span class="help-block" style="font-size: 20px"
            >To enable or disable a given permission, just check or uncheck the appropriated
            box!</span
          >
          <ul class="list-inline" style="padding: 10px">
            <li
              *ngFor="let resource of selectedResources"
              style="vertical-align: top; display: inline-block"
            >
              &#x25ba;<span>{{ resource.resourceName }}</span>
              <ul>
                <li *ngFor="let securedAction of resource.securedActions">
                  <label>
                    <input
                      [disabled]="role.id == 1 && resource.resourceName == 'Security'"
                      type="checkbox"
                      [(ngModel)]="securedAction.selected"
                      (change)="toggleSecuredAction(securedAction)"
                    />
                    <em>{{ securedAction.accessName }}</em>
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="accordion-item" [isOpen]="false" #subscriptions *ngIf="!role.isNew">
      <div class="accordion-header" id="headingFour">
        <div class="row" style="cursor: pointer">
          <div class="col-xs-12">
            <h5 class="mb-0">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                <span class="material-icons">people</span>Members
              </button>
            </h5>
          </div>
        </div>
      </div>
      <div
        id="collapseFour"
        class="accordion-collapse collapse"
        aria-labelledby="headingFour"
        data-parent="#SecurityEditAccordion"
      >
        <div class="accordion-body">
          <form class="form-horizontal" aria-label="members" role="form" #addMemberFormRef="ngForm">
            <div class="form-group">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-4">
                    <span class="help-block" style="font-size: 20px"
                      >To enroll a user, just type in the user's CAI and press enter</span
                    >
                    <div style="height: 50px">
                      <people-search-box
                        [model]="newUserName"
                        [allowAny]="'true'"
                        (modelChange)="addUser($event)"
                        (showPicker)="peoplePicker.show($event)"
                      ></people-search-box>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="specialUsers && specialUsers.length">
                    <span class="help-block" style="font-size: 20px">special users</span>
                    <button
                      *ngFor="let specialUser of specialUsers"
                      class="btn btn-outline-secondary"
                      style="width: auto; padding-top: 2px"
                      (click)="addSpecialUser(specialUser)"
                    >
                      <em class="material-icons">person_add</em>
                      {{ specialUser }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-md-12">
                <h4 class="control-label" style="font-size: 20px">Enrolled Users</h4>
                <button
                  title="Remove this User from the Role"
                  class="btn btn-outline-secondary"
                  style="width: auto; padding-top: 2px"
                  *ngFor="let person of role.subscriptions"
                  (click)="removeUser(person)"
                >
                  <em class="material-icons">person_remove</em>
                  {{ person.displayName }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <people-picker #peoplePicker (personSelected)="addUser($event)"></people-picker>
</div>
